export default __webpack_public_path__ + "images/8475adf3da1fdd585f4b5680b7f11097.png";